import { useMemo } from "react";
import { useEmailTriggers } from "./useEmailTriggers";
import { EmailTemplateApi } from "api/emailtemplates/emailtemplatesApi";

export interface EmailTemplateOption {
  value: string;
  label: string;
  template: EmailTemplateApi;
  triggerName?: string; // Optional trigger context
}

export const useEmailTemplateOptions = () => {
  const { loading: isLoading, triggers } = useEmailTriggers();

  // Extract all templates from all triggers and flatten them
  const allTemplates = useMemo(() => {
    return triggers.flatMap((trigger) =>
      trigger.templates.map((template) => ({
        ...template,
        triggerName: trigger.name, // Add trigger context for better labeling
      })),
    );
  }, [triggers]);

  const options: EmailTemplateOption[] = useMemo(() => {
    return allTemplates
      .filter((template) => template.isActive) // Only active templates
      .map((template) => ({
        value: template.id.toString(),
        label: `${template.name} (${template.triggerName})`, // Include trigger context in label
        template: template,
        triggerName: template.triggerName,
      }));
  }, [allTemplates]);

  return {
    options,
    isLoading,
    templates: allTemplates.filter((template) => template.isActive),
    triggers, // Expose triggers in case they're needed
  };
};
